<template>
<div>
 <xr-create
    :loading="loading"
    :title="title"
    :confirm-button-text="sureBtnTitle"
    @close="close"
    @save="saveClick">
    <!-- <i slot="title-append" class="wk wk-icon-fill-help wk-help-tips" data-type="11" data-id="38" /> -->
    <create-sections title="基本信息">
      <el-form
        ref="crmForm"
        :model="fieldForm"
        :rules="fieldRules"
        :validate-on-rule-change="false"
        class="wk-form"
        label-position="top"
        novalidate
        @submit.native.prevent>
        <wk-form-items
          v-for="(children, index) in fieldList"
          :key="index"
          :field-from="fieldForm"
          :field-list="children"
          @change="formChange"
        >
          <template slot-scope="{ data }">
            <crm-relative-cell
              v-if="data && data.formType == 'customer'"
              :value="fieldForm[data.field]"
              :disabled="data.disabled"
              relative-type="customer"
              @value-change="otherChange($event, data)"
            />
            <crm-relative-cell
              v-if="data && data.formType == 'relation_contract'"
              :value="fieldForm[data.field]"
              :disabled="data.disabled"
              relative-type="relation_contract"
              @value-change="otherChange($event, data)"
            />
            <crm-relative-cell
              v-if="data && (data.formType == 'business' || data.formType == 'contacts')"
              :value="fieldForm[data.field]"
              :disabled="data.disabled"
              :relation="data.relation"
              :relative-type="data.formType"
              @value-change="otherChange($event, data)"
            />
            <xh-product
              v-if="data && data.formType == 'product'"
              ref="productList"
              :value="fieldForm[data.field]"
              @value-change="otherChange($event, data)"
            />
            <XhPlan
              v-if="data && data.formType == 'receivablePlans'"
              ref="planList"
              :data-value="fieldForm[data.field]"
              @value-change="otherChange($event, data)"
            />
          </template>
        </wk-form-items>
      </el-form>
    </create-sections>

    <create-sections
      v-if="wkFlowList"
      title="审核信息">
      <template slot="header">
        <crm-tooltip
          v-if="flowRemarks"
          :content="flowRemarks"
          effect="dark"
          placement="top">
          <i class="wk wk-help wk-help-tips" style="margin-left: 8px;" />
        </crm-tooltip>
      </template>
      <wk-approval-flow-apply
        :data="wkFlowList"
        style="padding: 15px;"
      />
    </create-sections>

    <el-button
      slot="footer"
      type="primary"
      plain
      @click.native="debouncedSaveField(true)">保存草稿</el-button>
  </xr-create>
  <ContractOccupyConflict
    :info="occupyConflictInfo"
    :dialogVisible="showOccupyConflict"
    @cancel="conflictCancel"
    @continueSubmit="continueSubmit"
  >
  </ContractOccupyConflict>
</div>
 
</template>

<script>
import { filedGetFieldAPI } from '@/api/crm/common'
import {
  crmContractSaveAPI,
  crmContractFirstAPI,
  postCrmCheckForConflicts
} from '@/api/crm/contract'
import { crmBusinessProductAPI } from '@/api/crm/business'
import XrCreate from '@/components/XrCreate'
import CreateSections from '@/components/CreateSections'
import WkFormItems from '@/components/NewCom/WkForm/WkFormItems'
import { CrmRelativeCell } from '@/components/CreateCom'
import WkApprovalFlowApply from '@/components/Examine/WkApprovalFlowApply'
import WkApprovalFlowApplyMixin from '@/components/Examine/mixins/WkApprovalFlowApply'
import ContractOccupyConflict from '@/wkcrmViews/crm/components/ContractOccupyConflict.vue'
import crmTypeModel from '@/wkcrmViews/crm/model/crmTypeModel'
import CustomFieldsMixin from '@/mixins/CustomFields'
import XhPlan from '../receivablesPlan/components/XhPlan';
import { debounce } from 'throttle-debounce'
import { objDeepCopy } from '@/utils'
import eventLib from '@/common/utils/document-event'

export default {
  // 新建编辑
  name: 'ContractCreate',

  components: {
    XrCreate,
    CreateSections,
    CrmRelativeCell,
    XhProduct: () => import('../product/components/XhProduct'),
    XhPlan,
    WkFormItems,
    WkApprovalFlowApply,
    ContractOccupyConflict
  },

  mixins: [CustomFieldsMixin, WkApprovalFlowApplyMixin],

  props: {
    action: {
      type: Object,
      default: () => {
        return {
          type: 'save',
          id: '',
          data: {}
        }
      }
    }
  },

  data() {
    return {
      loading: false,
      baseFields: [],
      fieldList: [],
      fieldForm: {},
      fieldRules: {},
      occupyConflictInfo: {},

      // 审批信息
      flowRemarks: '',
      wkFlowList: null, // 有值有审批流
      showOccupyConflict: false, // 档期冲突弹窗
      relationContractField: '', // 记录关联合同的Field
      brandField: '' // 记录品牌的Field
    }
  },

  computed: {
    title() {
      if (this.action.title) {
        return this.action.title
      }
      return this.action.type === 'update' ? '编辑合同' : '新建合同'
    },

    // 确认名称
    sureBtnTitle() {
      if (this.wkFlowList) {
        return '提交审核'
      }
      return '保存'
    },
     isFirstSigned() { // 是否为首签客户key
      return this.baseFields.find(item => item.name.includes('是否首签客户'))?.fieldName
    },
  },

  watch: {
    "fieldForm.customerId":{
      handler(val){
        this.getIsFirstSigned(val)
      },
      immediate:true
    }
  },

  created() {
    this.debouncedSaveField = debounce(300, this.saveClick)

    this.getField()
  },

  mounted() {},

  beforeDestroy() {},

  methods: {
    /**
     * 获取数据
     */
    getField() {
      this.loading = true
      const params = {
        label: crmTypeModel.contract
      }

      if (this.action.type == 'update') {
        params.id = this.action.id
      }

      filedGetFieldAPI(params)
        .then(res => {
          const list = res.data || []

          const assistIds = this.getFormAssistIds(list)

          const baseFields = []
          const fieldList = []
          const fieldRules = {}
          const fieldForm = {}
          list.forEach(children => {
            const fields = []
            children.forEach(item => {
              if (item.formType == 'relation_contract') {
                this.relationContractField = item.fieldName
              } else if (item.formType == 'brands' || item.formType == 'brand') {
                this.brandField = item.fieldName
                item.config = {
                  relativeCustomer: true,
                  customerField: 'customerId'
                }
              }

              const temp = this.getFormItemDefaultProperty(item)
              temp.show = !assistIds.includes(item.formAssistId)

              const canEdit = this.getItemIsCanEdit(item, this.action.type)
              // 是否能编辑权限
              if (temp.show && canEdit) {
                // 自动生成编号
                if (item.autoGeneNumber == 1) {
                  temp.placeholder = '根据编号规则自动生成，支持手动输入'
                  const copyItem = objDeepCopy(item)
                  copyItem.isNull = 0
                  fieldRules[temp.field] = this.getRules(copyItem)
                } else {
                  fieldRules[temp.field] = this.getRules(item)
                }
              }

              // 是否可编辑
              temp.disabled = !canEdit

              // 禁止某些业务组件选择
              if (
                temp.formType == 'contacts' ||
                temp.formType == 'customer' ||
                temp.formType == 'business'
              ) {
                if (this.action.type == 'relative') {
                  const relativeDisInfos = {
                    contacts: { customer: true },
                    customer: { customer: true },
                    business: { customer: true, business: true }
                  }

                  // 在哪个类型下添加
                  const relativeTypeDisInfos =
                    relativeDisInfos[this.action.crmType]
                  if (relativeTypeDisInfos) {
                    // 包含的字段值
                    temp.disabled = relativeTypeDisInfos[item.formType] || false
                  }
                } else if (this.action.type != 'update') {
                  temp.disabled =
                    item.formType === 'business' || item.formType === 'contacts'
                }
              }

              // 处理关联
              if (
                (this.action.type == 'relative' ||
                  this.action.type == 'update') &&
                (item.formType == 'business' ||
                  item.formType == 'contacts' ||
                  item.formType == 'contract' ||
                  item.formType == 'relation_contract')
              ) {
                const customerObj = this.getItemRelatveInfo(list, 'customer')
                if (customerObj) {
                  const customerItem = objDeepCopy(customerObj)
                  if (
                    item.formType == 'business' ||
                    item.formType == 'contacts'
                  ) {
                    customerItem['moduleType'] = 'customer'
                    temp['relation'] = customerItem
                  } else if (
                    item.formType == 'contract' ||
                    item.formType == 'relation_contract'
                  ) {
                    customerItem['moduleType'] = 'customer'
                    customerItem['params'] = { checkStatus: [1, 10] }
                    temp['relation'] = customerItem
                  }
                }
              }
              // 特殊字段允许多选
              this.getItemRadio(item, temp)

              // 获取默认值
              // 非编辑情况下 填充默认值
              if (temp.show) {
                if (
                  this.action.type !== 'update' &&
                  item.fieldName === 'orderDate'
                ) {
                  fieldForm[temp.field] = this.$moment().format('YYYY-MM-DD')
                } else {
                  fieldForm[temp.field] = this.getItemValue(
                    item,
                    this.action.data,
                    this.action.type
                  )
                }
              }

              // 复制合同时，不复制自定义编号类型的字段
              if (this.action.isCopy && temp.formType === 'serial_number') {
                fieldForm[temp.field] = null
              }

              if (temp.formType === 'receivablePlans') {
                let plans = [];
                if (this.action.type === 'update') {
                  if (temp.value && Array.isArray(temp.value)) {
                    plans = temp.value.map((e) => ({
                      entity: { ...e },
                      field: []
                    }));
                  }
                }
                fieldForm[temp.field] = plans;
              }

              fields.push(temp)
              baseFields.push(item)
            })
            fieldList.push(fields)
          })

          // 填充商机关联的产品信息
          if (this.action.type == 'relative') {
            const businessData = this.action.data.business
            if (businessData) {
              this.getBusinessProduct(businessData.businessId)
                .then(resData => {
                  const businessData = resData || {}
                  fieldForm.product = {
                    product: businessData.list,
                    totalPrice: businessData.money,
                    discountRate: businessData.discountRate
                  }
                  fieldForm.money = businessData.money || ''
                })
                .catch(() => {})
            }
          }

          console.log(fieldList, 'fieldList')
          console.log(fieldForm, 'fieldForm')
          this.baseFields = baseFields
          this.fieldList = fieldList
          this.fieldForm = fieldForm
          this.fieldRules = fieldRules

          // 审核信息
          this.initWkFlowData(
            {
              params: { label: 1 },
              fieldForm: this.fieldForm
            },
            res => {
              this.wkFlowList = res.list
              this.flowRemarks = res.resData ? res.resData.remarks : ''
            }
          )
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    /**
     * 保存
     */
    saveClick(isDraft = false) {
      this.loading = true
      const crmForm = this.$refs.crmForm
      console.log('crmForm',crmForm)
      crmForm.validate(async valid => {
        if (valid) {
          if (
            this.fieldForm.product.product &&
            this.fieldForm.product.product.length
          ) {
            if (!this.$refs.productList[0].valid()) {
              this.loading = false
              return
            }
          }
          const {
            product: { product }
          } = this.fieldForm
          const schedules = product.map(item => ({
            id: item.productId,
            startAt: item.activityStartDate,
            endAt: item.activityEndDate
          }))
          const hasRelationContract =
            !!this.relationContractField &&
            !!this.fieldForm[this.relationContractField] &&
            !!this.fieldForm[this.relationContractField].length
          if (!isDraft && schedules.length && !hasRelationContract) {
            const conflicts = await postCrmCheckForConflicts({ schedules })
            if (conflicts && conflicts.total > 0) {
              this.showOccupyConflict = true
              this.occupyConflictInfo = conflicts
            } else {
              this.continueSubmit(isDraft)
            }
          } else {
            this.continueSubmit(isDraft)
          }
        } else {
          this.loading = false
          // 提示第一个error
          this.getFormErrorMessage(crmForm)
          return false
        }
      })
    },
    conflictCancel() {
      this.loading = false
      this.showOccupyConflict = false
    },
    continueSubmit(isDraft = false) {
      const wkFlowResult = this.validateWkFlowData(this.wkFlowList)
      if (wkFlowResult.pass || isDraft) {
        const params = this.getSubmiteParams(
          [].concat.apply([], this.fieldList),
          this.fieldForm
        )
        if (isDraft) {
          params.entity.checkStatus = 5
        }
        if (wkFlowResult.data) {
          params.examineFlowData = wkFlowResult.data
        }
        this.submiteParams(params)
      } else {
        this.loading = false
        this.$crmMessage.error('请完善审批信息')
      }
    },

    /**
     * 提交上传
     */
    submiteParams(params) {
      if (this.action.type == 'update' && !this.action.isCopy) {
        params.entity.contractId = this.action.id
        params.entity.batchId = this.action.batchId
      }

      // 相关添加时候的多余提交信息
      if (
        this.action.relativeData &&
        Object.keys(this.action.relativeData).length
      ) {
        params = { ...params, ...this.action.relativeData }
      }

      crmContractSaveAPI(params)
        .then(res => {
          this.loading = false
          if (this.action.isCopy) {
            this.$crmMessage.success('操作成功')
          } else {
            this.$crmMessage.success(
              this.action.type == 'update' ? '编辑成功' : '添加成功'
            )
          }

          this.close()

          // 保存成功
          this.$emit('save-success', {
            type: 'contract'
          })
          eventLib.dispatch('UPDATE_EXAMINE')
        })
        .catch((err) => {
          console.log(err, 'err')
          this.loading = false
        })
    },

    /**
     * 验证唯一
     */
    UniquePromise({ field, value }) {
      return this.getUniquePromise(field, value, this.action)
    },

    /**
     * change
     */
    formChange(field, index, value, valueList) {
      // 审批流逻辑
      this.debouncedGetWkFlowList(field.field, this.fieldForm)

      if (
        ['select', 'checkbox'].includes(field.formType) &&
        field.remark === 'options_type' &&
        field.optionsData
      ) {
        const { fieldForm, fieldRules } = this.getFormContentByOptionsChange(
          this.fieldList,
          this.fieldForm
        )
        this.fieldForm = fieldForm
        this.fieldRules = fieldRules
      }
      this.$nextTick(() => {
        this.fieldRules = this.getFormRulesByOptionsChange(
          this.fieldList,
          this.fieldForm
        )
      })
    },

    /**
     * 地址change
     */
    otherChange(data, field) {
      console.log(data, field, 'change');
      if (field.formType === 'customer') {
        let contractForCount = 0
        for (
          let mainIndex = 0;
          mainIndex < this.fieldList.length;
          mainIndex++
        ) {
          const children = this.fieldList[mainIndex]
          for (let index = 0; index < children.length; index++) {
            const element = children[index]
            // 需要处理 需关联客户信息或客户下信息
            const handleFields = ['businessId', 'contactsId', 'companyUserId']

            // 添加请求关联
            const addRelation = ['businessId', 'contactsId']

            // 需要disabled
            const addDisabled = ['businessId', 'contactsId']

            // 复制
            const getValueObj = {
              contactsId: data => {
                if (!data.contactsId) {
                  return []
                }
                return [
                  {
                    name: data.contactsName || '',
                    contactsId: data.contactsId
                  }
                ]
              },
              companyUserId: data => {
                if (!data.ownerUserId) {
                  return []
                }
                return [
                  {
                    realname: data.ownerUserName || '',
                    userId: data.ownerUserId
                  }
                ]
              }
            }

            if (handleFields.includes(element.field)) {
              if (data.value.length > 0) {
                element.disabled = false

                // 增加关联信息
                const customerItem = data.value[0]
                if (addRelation.includes(element.field)) {
                  customerItem['moduleType'] = 'customer'
                  element['relation'] = customerItem
                }

                // 填充值
                if (getValueObj[element.field]) {
                  this.fieldForm[element.field] = getValueObj[element.field](
                    customerItem
                  )
                } else {
                  this.fieldForm[element.field] = []
                }
              } else {
                // 禁用
                element.disabled = !!addDisabled.includes(element.field)

                if (addRelation.includes(element.field)) {
                  element['relation'] = {}
                }

                this.fieldForm[element.field] = []
              }

              contractForCount++
              if (contractForCount == handleFields.length) {
                break
              }
            }
            if (element.name === '是否首签客户') {
              const customerItem = data.value[0]
              if (customerItem && customerItem.customerId) {
                crmContractFirstAPI({
                  customerId: customerItem.customerId
                }).then(data => {
                  if (data.data) {
                    this.fieldForm[element.field] = '是'
                    element.value = '是'
                  } else {
                    this.fieldForm[element.field] = '否'
                    element.value = '否'
                  }
                })
              } else {
                this.fieldForm[element.field] = ''
                element.value = ''
              }
            }
          }
        }

        // 重置产品信息
        this.fieldForm.product = {
          product: [],
          totalPrice: '',
          discountRate: ''
        }
        this.fieldForm.money = ''

        // 重置品牌
        if (this.brandField) {
          this.fieldForm[this.brandField] = ''
        }

        this.debouncedGetWkFlowList('money', this.fieldForm)
      } else if (field.formType === 'business') {
        if (data.value.length > 0) {
          this.getBusinessProduct(data.value[0].businessId)
            .then(resData => {
              const businessData = resData || {}
              this.fieldForm.product = {
                product: businessData.list,
                totalPrice: businessData.money,
                discountRate: businessData.discountRate
              }
              this.fieldForm.money = businessData.money || ''
              this.debouncedGetWkFlowList('money', this.fieldForm)
            })
            .catch(() => {})
        }
      } else if (field.formType === 'product') {
        this.fieldForm.money = data.value.totalPrice || ''
        this.debouncedGetWkFlowList('money', this.fieldForm)
      }
      // 选择关联合同的额外处理，用于显示合同名称，否则只会显示合同编号
      if (field.formType === 'relation_contract') {
        const contractVal = data.value.map((v, index) => {
          const result = {
            contractId: v.contractId,
            contractNum: v.num || v.contractNum,
            contractName: v.name || v.contractName
          }
          this.$set(data.value, index, result)
          return result
        })
      }
      this.$set(this.fieldForm, field.field, data.value)
      this.$refs.crmForm.validateField(field.field)
    },

    /**
     * 获取商机的产品信息进行填充
     */
    getBusinessProduct(businessId) {
      return new Promise((resolve, reject) => {
        crmBusinessProductAPI({
          businessId: businessId,
          pageType: 0
        })
          .then(res => {
            resolve(res.data)
          })
          .catch(err => {
            reject(err)
          })
      })
    },

    /**
     * 关闭
     */
    close() {
      this.$emit('close')
    },
    /**
     * 如果有客户自动带入是否首签
     */
    getIsFirstSigned(customer){
       if (customer && customer.length && customer[0].customerId && this.isFirstSigned) {
          crmContractFirstAPI({
            customerId: customer[0].customerId
          }).then(data => {
            if (data.data) {
              this.fieldForm[this.isFirstSigned] = '是'
            } else {
              this.fieldForm[this.isFirstSigned] = '否'
            }
          })
        } 
    }
  }
}
</script>

<style lang="scss" scoped>
.wk-form {
  /deep/ .el-form-item.is-product {
    flex: 0 0 100%;
    width: 0;
  }
}
</style>
